import { FC, useRef } from 'react';
import { SliderImage } from './styles';
import { GalleryItemProps } from './types';
import { IframeItem } from './IframeItem';
import { getVideoLink } from 'src/utils/getVideoLink';
import { isVimeoUrl, isYoutubeUrl } from 'src/utils';

export const GalleryItem: FC<GalleryItemProps & { children?: any }> = ({
  item,
  index,
  currentIndex,
  onPointerUp = () => {},
}) => {
  const imageRef = useRef(null);

  if (item.endsWith('.mp4')) {
    return (
      <div
        ref={imageRef}
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <video
          playsInline
          controls
          src={item}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            aspectRatio: '1920/1080'
          }}
        />
      </div>
    );
  }

  if (
    item.endsWith('.jpg') ||
    item.endsWith('.png') ||
    item.endsWith('.gif') ||
    item.endsWith('.webp')
  ) {
    return (
      <div
        ref={imageRef}
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <SliderImage src={item} onPointerUp={onPointerUp} />
      </div>
    );
  }
  if (isVimeoUrl(item) || isYoutubeUrl(item)) {
    return (
      <iframe
        src={currentIndex === index ? getVideoLink(item) : ''}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={`iframe-${index}`}
        style={{
          width: '100%',
          height: '100%',
          aspectRatio: '1920/1080'
        }}
      />
    );
  }
  if (item.endsWith('.pdf')) {
    return <IframeItem item={item} index={index} useGoogleViewer />;
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'gray',
      }}
    >
      <p>Unsupported content type</p>
    </div>
  );
};
